import React, { Component } from 'react';
// Precios en USD
export const CURRENT_PRICE_USD = 11.99;
export const ORIGINAL_PRICE_USD = 45.99;
export const SAVINGS_USD = 34.0;
// Componente para mostrar el precio con ahorro
export const PriceDisplay = () => {
  return <div className="price-display mt-2" data-id="element-470">
      <div className="text-sm text-gray-600" data-id="element-471">
        <span className="line-through" data-id="element-472">Antes: $45.99</span>{' '}
        <span className="text-green-600 font-bold" data-id="element-473">Ahorro $34</span>
      </div>
    </div>;
};